import { render, staticRenderFns } from "./SeeYouSoon.vue?vue&type=template&id=2204e05e&scoped=true"
import script from "./SeeYouSoon.vue?vue&type=script&lang=js"
export * from "./SeeYouSoon.vue?vue&type=script&lang=js"
import style0 from "./SeeYouSoon.vue?vue&type=style&index=0&id=2204e05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204e05e",
  null
  
)

export default component.exports